import { OverlayRef } from '@angular/cdk/overlay';

import { Observable, Subject } from 'rxjs';

import { DialogWidth } from './dialog-config';
import {
  DialogContainerAnimationState,
  DialogContainerComponent,
} from './dialog-container/dialog-container.component';

export class DialogRef<T = any, DialogResult = any> {
  public componentInstance: T;
  public afterClosed: Observable<DialogResult | undefined>;

  private afterClosedSubject = new Subject<DialogResult | undefined>();
  private result: DialogResult | undefined;

  constructor(
    public overlayRef: OverlayRef,
    public containerInstance: DialogContainerComponent,
  ) {
    this.afterClosed = this.afterClosedSubject.asObservable();

    containerInstance.animationStateChange.subscribe((state: DialogContainerAnimationState) => {
      if (state === 'exit-start') {
        // Transition the backdrop in parallel with the dialog.
        this.overlayRef.detachBackdrop();
      } else if (state === 'exit') {
        this.overlayRef.dispose();
        this.afterClosedSubject.next(this.result);
        this.afterClosedSubject.complete();
        // @ts-ignore
        delete this.result;
      }
    });
  }

  public setContainerWidth(width: DialogWidth): void {
    this.containerInstance.dialogConfig = { ...this.containerInstance.dialogConfig, width };
    this.containerInstance.detectChanges();
  }

  public close(dialogResult?: DialogResult): void {
    this.result = dialogResult;
    return this.containerInstance.close();
  }
}
